import UserProfileHeader from './UserProfileHeader';
export default UserProfileHeader;